import {Cell, Worksheet} from "exceljs";

export const mergeHeaderCellsByColSpan = ({
                                              worksheet,
                                              dataSetRowIndex,
                                              rowIndex,
                                              colIndex,
                                              colSpan,
                                          }: {
    worksheet: Worksheet,
    dataSetRowIndex: number,
    rowIndex: number,
    colIndex: number,
    colSpan: number,
}) => {
    worksheet.mergeCells(dataSetRowIndex + rowIndex + 1, colIndex + 1, dataSetRowIndex + rowIndex + 1, colIndex + colSpan);
}

export const mergeHeaderCellsByRowSpan = ({
                                              worksheet,
                                              dataSetRowIndex,
                                              colIndex,
                                              rowIndex,
                                              rowSpan,
                                              cell,

                                          }: {
    worksheet: Worksheet,
    dataSetRowIndex: number,
    colIndex: number,
    rowIndex: number,
    rowSpan: number,
    cell: Cell,
}) => {

    const start = dataSetRowIndex + rowIndex + 1
    const end = dataSetRowIndex + rowIndex + rowSpan
    const col = colIndex + 1

    if (cell.isMerged) {
        return
    }
    worksheet.mergeCells(start, col, end, col);
}